module.exports = __webpack_public_path__ + "img/devops.6fea02d9.png";